import { Search, MapPin, Clock, DollarSign, Filter, ChevronRight, Bookmark } from 'lucide-react';


const jobs = [
  { id: 1, title: 'Senior Product Designer', company: 'Messego Corp', location: 'Remote', type: 'Full-time', salary: '$120k - $160k', time: '2h ago', logo: 'https://picsum.photos/seed/logo1/100/100' },
  { id: 2, title: 'Full Stack Engineer', company: 'TechFlow', location: 'New York, NY', type: 'Contract', salary: '$80 - $120 / hr', time: '5h ago', logo: 'https://picsum.photos/seed/logo2/100/100' },
  { id: 3, title: 'Marketing Manager', company: 'Growthly', location: 'San Francisco, CA', type: 'Full-time', salary: '$90k - $130k', time: '1d ago', logo: 'https://picsum.photos/seed/logo3/100/100' },
  { id: 4, title: 'Customer Success Lead', company: 'SaaSify', location: 'Remote', type: 'Full-time', salary: '$70k - $100k', time: '2d ago', logo: 'https://picsum.photos/seed/logo4/100/100' },
];

export default function Career() {
  return (
    <div className="space-y-8">
      <header className="flex flex-col md:flex-row md:items-center justify-between gap-4">
        <div>
          <h1 className="text-3xl font-bold tracking-tight">Career Center</h1>
          <p className="text-neutral-500 dark:text-neutral-400">Find your next opportunity or hire top talent.</p>
        </div>
        <div className="flex items-center gap-3">
          <button className="flex items-center gap-2 px-4 py-2 bg-white dark:bg-neutral-900 border border-neutral-200 dark:border-neutral-800 rounded-xl text-sm font-medium hover:bg-neutral-50 dark:hover:bg-neutral-950 transition-colors">
            <Filter className="w-4 h-4" />
            Filters
          </button>
          <button className="flex items-center gap-2 px-4 py-2 bg-neutral-900 text-white rounded-xl text-sm font-medium hover:bg-neutral-800 transition-colors shadow-lg shadow-neutral-900/20">
            Post a Job
          </button>
        </div>
      </header>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
        {/* Job Listings */}
        <div className="lg:col-span-2 space-y-4">
          <div className="relative">
            <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-neutral-400 dark:text-neutral-500" />
            <input 
              type="text" 
              placeholder="Search jobs, companies, or keywords..." 
              className="w-full pl-12 pr-4 py-4 bg-white dark:bg-neutral-900 border border-neutral-200 dark:border-neutral-800 rounded-2xl shadow-sm dark:shadow-none focus:outline-none focus:ring-2 focus:ring-neutral-900/5 transition-all"
            />
          </div>

          <div className="space-y-4">
            {jobs.map((job) => (
              <div key={job.id} className="group bg-white dark:bg-neutral-900 p-6 rounded-3xl border border-neutral-200 dark:border-neutral-800 hover:border-neutral-900 transition-all cursor-pointer shadow-sm dark:shadow-none">
                <div className="flex items-start justify-between">
                  <div className="flex gap-4">
                    <div className="w-14 h-14 rounded-2xl overflow-hidden bg-neutral-100 dark:bg-neutral-800 border border-neutral-100 dark:border-neutral-800">
                      <img src={job.logo} alt={job.company} referrerPolicy="no-referrer" />
                    </div>
                    <div>
                      <h3 className="font-bold text-lg group-hover:text-neutral-900 dark:group-hover:text-neutral-50 transition-colors">{job.title}</h3>
                      <p className="text-sm font-medium text-neutral-600 dark:text-neutral-300">{job.company}</p>
                      <div className="flex flex-wrap gap-4 mt-3">
                        <div className="flex items-center gap-1.5 text-xs text-neutral-500 dark:text-neutral-400 font-medium">
                          <MapPin className="w-3.5 h-3.5" />
                          {job.location}
                        </div>
                        <div className="flex items-center gap-1.5 text-xs text-neutral-500 dark:text-neutral-400 font-medium">
                          <Clock className="w-3.5 h-3.5" />
                          {job.type}
                        </div>
                        <div className="flex items-center gap-1.5 text-xs text-neutral-500 dark:text-neutral-400 font-medium">
                          <DollarSign className="w-3.5 h-3.5" />
                          {job.salary}
                        </div>
                      </div>
                    </div>
                  </div>
                  <button className="p-2 rounded-full hover:bg-neutral-100 dark:hover:bg-neutral-800 text-neutral-400 dark:text-neutral-500 hover:text-neutral-900 dark:hover:text-neutral-50 transition-colors">
                    <Bookmark className="w-5 h-5" />
                  </button>
                </div>
                <div className="mt-6 flex items-center justify-between pt-6 border-t border-neutral-50">
                  <span className="text-[10px] font-bold text-neutral-400 dark:text-neutral-500 uppercase tracking-widest">{job.time}</span>
                  <button className="flex items-center gap-1 text-sm font-bold text-neutral-900 dark:text-neutral-50 hover:gap-2 transition-all">
                    Apply Now
                    <ChevronRight className="w-4 h-4" />
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Sidebar */}
        <div className="space-y-6">
          <div className="bg-neutral-900 rounded-[2rem] p-8 text-white">
            <h3 className="text-xl font-bold mb-4">Complete Your Profile</h3>
            <p className="text-neutral-400 dark:text-neutral-500 text-sm mb-6">Users with complete profiles are 5x more likely to get hired.</p>
            <div className="w-full bg-white/10 h-2 rounded-full mb-6 overflow-hidden">
              <div className="bg-white w-[65%] h-full rounded-full"></div>
            </div>
            <button className="w-full bg-white text-neutral-900 py-3 rounded-xl font-bold hover:bg-neutral-100 transition-colors">
              Finish Profile
            </button>
          </div>

          <div className="bg-white dark:bg-neutral-900 rounded-[2rem] p-6 border border-neutral-200 dark:border-neutral-800 shadow-sm dark:shadow-none">
            <h3 className="font-bold mb-4">Top Networking</h3>
            <div className="space-y-4">
              {[1, 2, 3].map((i) => (
                <div key={i} className="flex items-center justify-between">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full overflow-hidden bg-neutral-100 dark:bg-neutral-800">
                      <img src={`https://picsum.photos/seed/user${i}/100/100`} alt="User" referrerPolicy="no-referrer" />
                    </div>
                    <div>
                      <p className="text-sm font-bold">User {i}</p>
                      <p className="text-[10px] text-neutral-500 dark:text-neutral-400">Product Manager</p>
                    </div>
                  </div>
                  <button className="text-[10px] font-bold text-neutral-900 dark:text-neutral-50 bg-neutral-100 dark:bg-neutral-800 px-3 py-1.5 rounded-lg hover:bg-neutral-900 hover:text-white transition-all">
                    Connect
                  </button>
                </div>
              ))}
            </div>
            <button className="w-full mt-6 text-sm font-bold text-neutral-500 dark:text-neutral-400 hover:text-neutral-900 dark:hover:text-neutral-50">View more</button>
          </div>
        </div>
      </div>
    </div>
  );
}
